import 'array-flat-polyfill';
import { NEW_LINE_REGEX } from "./constants";
export var getParagraphsFromStrings = function getParagraphsFromStrings() {
  for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
    strings[_key] = arguments[_key];
  }

  return strings.map(function (string) {
    return string.split(NEW_LINE_REGEX).map(function (subString) {
      return subString.trim();
    }).filter(function (subString) {
      return subString && !subString.match(NEW_LINE_REGEX);
    });
  }).flat();
};